import { render, staticRenderFns } from "./ClientDeleteScreen.vue?vue&type=template&id=4826f753&scoped=true&"
import script from "./ClientDeleteScreen.vue?vue&type=script&lang=js&"
export * from "./ClientDeleteScreen.vue?vue&type=script&lang=js&"
import style0 from "./ClientDeleteScreen.vue?vue&type=style&index=0&id=4826f753&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4826f753",
  null
  
)

export default component.exports